import React from "react";
import Typewriter from "typewriter-effect";

function Type() {
  return (
    <>
      <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
        <span style={{ fontSize: "32px" }}>I'm a</span>
        <Typewriter
          options={{
            strings: [
              "MERN Stack Developer",
              "Software Developer",
              "Open Source Contributor",
            ],
            autoStart: true,
            loop: true,
            deleteSpeed: 50,
          }}
        />
      </div>
    </>
  );
}

export default Type;
